import { PLANNING } from "@common/flags"
import type { QueryClient } from "@tanstack/react-query"
import { requireFeatureFlag } from "@/lib/require-feature-flag"
import { requirePermission } from "@/lib/require-permission"

export async function requirePlanPages(
  queryClient: QueryClient,
): Promise<void> {
  await requirePermission(queryClient, "work_package:read", "/")
  await requireFeatureFlag(queryClient, PLANNING)
}
